import React from 'react';
import { getStyle } from '../../components';
import { PropTypes } from 'prop-types';
import autobind from 'autobind-decorator';
import { SecondKillComp } from '../../widgets';
import { dateformat } from '../../utils';
import store from '../../store';
import './AppList.less';




// 定义与 SecondKillComp 一致的 text 类型
type SecondKillCompText = '开始秒杀' | '开始抢购' | '结束秒杀' | '结束抢购';

// 定义 Props 类型
interface AppListProps {
  prefixCls?: string;
  data: {
    mastermap: string;
    video: string;
    videoCover: string;
    productId: string | number;
    skuCode: string | number;
    productAd: string;
    brandsName: string;
    productName: string;
    minPrice: number | string;
    price: number | string;
    minMarkPrice: number | string;
    marketPrice: number | string;
    status: number;
    virtual: boolean;
    commission: number | string;
    labelImgList: string[];
  };
  shopHomeJia: (data: any) => void;
  isApp?: boolean;
  shareProc?: (data: any) => void;
  isSpecial?: boolean;
  date?: number; // 类型：number | undefined
  promotStatus?: number | null; // 类型：number | null | undefined
  type?: number; // 类型：number | undefined
  toApptaile?: (productId: string | number, skuCode: string | number, e?: React.MouseEvent<HTMLElement>) => void;
}

// 定义 State 类型
interface AppListState {
  isPlaying: boolean;
  isWifi: boolean;
}

class AppList extends React.Component<AppListProps, AppListState> {
  // 显式声明所有实例属性类型
  private videoRef: HTMLVideoElement | null;
  private setVideoRef: (element: HTMLVideoElement | null) => void;
  private dataType: { [key: string]: SecondKillCompText };

  static defaultProps: Partial<AppListProps> = {
    prefixCls: 'app-list',
    data: {
      mastermap: '',
      video: '',
      videoCover:'',
      productId: '',
      skuCode: '',
      productAd: '',
      brandsName: '',
      productName: '',
      minPrice: 0,
      price: 0,
      minMarkPrice: 0,
      marketPrice: 0,
      status: 0,
      virtual: false,
      commission: 0,
      labelImgList: [],
    },
    isApp: false,
    isSpecial: false,
    promotStatus: 0, // 兜底：默认值，避免 undefined
    type: 0, // 兜底：默认值，避免 undefined
    date: 0, // 兜底：默认值，避免 undefined
     // 核心：为可选函数添加兜底空函数，从根源避免 undefined
    shareProc: () => {},
    toApptaile: () => {}
  };

  constructor(props: AppListProps) {
    super(props);
    
    // 初始化 State
    this.state = {
      isPlaying: false,
      isWifi: true,
    };

    // 初始化 Ref 相关属性
    this.videoRef = null;
    
    // 定义回调 Ref 方法并指定类型
    this.setVideoRef = (element: HTMLVideoElement | null) => {
      this.videoRef = element;
    };

    // 初始化数据字典
    this.dataType = {
      '11': '开始秒杀',
      '12': '开始抢购',
      '21': '结束秒杀',
      '22': '结束抢购'
    };
  }

  componentDidMount() {
    // 检测网络类型
    this.checkNetworkType();
  }

  componentWillUnmount() {
    // 停止视频播放
    if (this.videoRef) {
      this.videoRef.pause();
    }
  }

  // 检测网络类型（ES5 兼容，使用 indexOf 替代 includes）
  private checkNetworkType = () => {
    const connection = (navigator.connection || navigator.mozConnection || navigator.webkitConnection) as Navigator['connection'];
    let isWifi = true;
    if (connection) {
      const type = (connection.type || '').toLowerCase();
      console.log('****打印网络类型****')
      console.log(type)
      // 改进的判断逻辑：桌面浏览器默认按WiFi处理
      isWifi = ['wifi', 'ethernet', 'wlan'].indexOf(type) !== -1;
      if(['wifi', 'ethernet', 'wlan'].indexOf(type) !== -1){
        //属于wifi,有线网络,默认进行播放，其它情况默认蜂窝数据
        isWifi = true;
      }else{
         isWifi = false;
      }
      console.log('当前网络是否为WIFI：' + isWifi)
      // 如果在桌面环境且检测到移动网络类型，默认按WiFi处理（因为桌面通常是有线/WiFi）
      // const networkType = (connection.effectiveType || '').toLowerCase();
      // if (!isWifi && (networkType === '4g' || networkType === '3g' || networkType === '2g')) {
      //   console.log('当前网络发现是桌面环境，默认按WIFI网络进行')
      //   console.log(networkType)
      //   isWifi = true;
      // }
    }
    
    // 设置状态，并在是WiFi时触发自动播放
    this.setState({ isWifi }, () => {
      const { data } = this.props;
      if (data.video && isWifi) {
        this.playVideo();
      }
    });
  };





  // 播放视频（静音）- 添加微信兼容处理
  private playVideo = () => {
    if (this.videoRef && !this.state.isPlaying) {
      const video = this.videoRef;
      
      // 微信浏览器特殊处理
      const playVideoHandler = () => {
        video.play().then(() => {
          this.setState({ isPlaying: true });
        }).catch(err => {
          console.log('自动播放失败:', err);
          this.setState({ isPlaying: false });
        });
      };

      // 检测是否在<-iOS->微信环境中
      const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      if (isWeixin && isIOS) {
        // iOS 微信需要使用 WeixinJSBridgeReady
        if ((window as any).WeixinJSBridge) {
          (window as any).WeixinJSBridge.invoke('getNetworkType', {}, () => {
            playVideoHandler();
          });
        } else {
          // 等待 WeixinJSBridge 就绪
          const weixinReadyHandler = () => {
            playVideoHandler();
            document.removeEventListener('WeixinJSBridgeReady', weixinReadyHandler);
          };
          document.addEventListener('WeixinJSBridgeReady', weixinReadyHandler);
        }
      } else {
        // 其他环境直接播放
        playVideoHandler();
      }
    }
  };

  // 显示活动文字 - 修复：处理 undefined 转为 null
  @autobind
  private _showText(promotStatus: number | null, type: number): SecondKillCompText {
    // 核心修复1：将 undefined 转为 null（适配参数类型要求）
     const status = promotStatus === undefined ? null : promotStatus;
    const typeNum = type === undefined ? 0 : type;
    const typeStr = `${status}${typeNum}`;
    
    // 兜底：如果没有匹配的值，返回默认值
    return this.dataType[typeStr] || '开始秒杀';
  }

  // 跳转商品详情 - 类型断言 + 空值保护
  @autobind
  private toAppDetail(data: any, e: React.MouseEvent<HTMLElement>) {
    // 类型断言：将 EventTarget 转为 HTMLElement
    const target = e.target as HTMLElement;
    // 空值保护：防止 target 为 null 或 className 不存在
    const targetClassName = (target && target.className) || '';
    
    if (targetClassName !== 'app-listadd_car_icon' && this.props.toApptaile) {
      this.props.toApptaile(data.productId, data.skuCode, e);
    }
  }

  // 跳转到视频详情页
  @autobind
  private goToVideoDetail(data: any, e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
    const { shopHomeJia, toApptaile } = this.props;
    
    // 存储数据到 sessionStorage，防止返回时数据丢失
    sessionStorage.setItem('videoDetailData', JSON.stringify({
      data: data,
      shopHomeJia: shopHomeJia,
      toApptaile: toApptaile
    }));
    
    if (this.context.router) {
      this.context.router.history.push({
        pathname: '/videoDetail',
        state: {
          data: data,
          shopHomeJia: shopHomeJia,
          toApptaile: toApptaile
        }
      });
    }
  }

  

  render() {
    const { prefixCls, data, shopHomeJia, isApp, shareProc, isSpecial, date, promotStatus, type } = this.props;
    const { isPlaying, isWifi } = this.state;
    const style = getStyle(this.props);
    const isBClass = isApp ? '-b' : '';
    const hasVideo = !!data.video;

    // 提前处理变量
    const statusVal = promotStatus === undefined ? null : promotStatus;
    const typeVal = type === undefined ? 0 : type;
    const killText = this._showText(statusVal, typeVal);
    const killDate = date ? dateformat(date, 'mm月dd日 HH:MM:ss') : '';

    return (
      <div 
        className={`top_box ${prefixCls}${isBClass}`} 
        style={style}
      >
        {/* 标签区域 */}
        <div
          className={`${prefixCls}label-box`}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => this.toAppDetail(data, e)}
        >
          {(data.labelImgList || []).map((item, index) => (
            <img src={item} key={index} alt="" />
          ))}
        </div>
        {/* 视频/图片容器 */}
        <div
          className={`${prefixCls}img_box cover_img_box video-container`}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => hasVideo ? this.goToVideoDetail(data, e) : this.toAppDetail(data, e)}
        >
          {/* 视频元素（有视频时显示） */}
          {hasVideo && (
            <video
              ref={this.setVideoRef}
              src={data.video}
              poster={data.videoCover}
              className={`product-video ${isPlaying ? 'playing' : 'paused'}`}
              muted // 列表页强制静音
              loop // 循环播放
              playsInline
              webkit-playsinline="true"
              style={{width: '100%'}}
              preload="metadata" // 仅预加载元数据，节省流量
            >
              您的浏览器不支持HTML5视频播放
            </video>
          )}
          
          {/* 无视频时显示商品主图，有视频但未播放时显示视频封面 */}
          {!hasVideo && (
            <img 
              src={data.mastermap} 
              alt={data.productName}
              className="product-cover"
            />
          )}
          {hasVideo && !isPlaying && (
            <img 
              src={data.videoCover || data.mastermap} 
              alt={data.productName}
              className="product-cover"
            />
          )}

          {/* 非WiFi提示（有视频但未播放时显示） */}
          {hasVideo && !isWifi && !isPlaying && (
            <div className="video-play-tip">
              <div className="play-icon" />
            </div>
          )}

          {/* 秒杀组件 - 核心修复2：处理 undefined 转为 null/兜底值 */}
          {
            // 先过滤无效值：promotStatus 不是 0/null/undefined，type 不是 0/undefined
            (promotStatus !== 0 && promotStatus != null) && (type !== 0 && type != null) && (
              <div className={'home-kill-box'}>
                <SecondKillComp
                  // 修复：将 undefined 转为 null
                   text={killText}
                   date={killDate}
                />
              </div>
            )
          }
        </div>

        {/* 商品简介 */}
        <div
          className={`${prefixCls}main_box`}
          style={{
            marginTop: store.status.isShowHead ? '1rem' : '0.8rem',
            paddingLeft: isSpecial ? '.8rem' : ''
          }}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => this.toAppDetail(data, e)}
        >
          <div className={`${prefixCls}main_top${isBClass}`}>{data.productAd}</div>
          <div className={`${prefixCls}main_middle${isBClass}`}>{`${data.brandsName}·${data.productName}`}</div>
          <div className={`${prefixCls}product_price`}>
            <span className={`${prefixCls}monye_icon`}>￥</span>
            <span className={`${prefixCls}monye`}>{data.minPrice || data.price}</span>
            <span className={`${prefixCls}market_price`}>
              ￥{data.minMarkPrice || data.marketPrice}
              <span className={`${prefixCls}market_price_line`} />
            </span>
          </div>
        </div>

        {/* 售罄提示 */}
        {isSpecial 
          ? (data.status === -1 && <div className={`${prefixCls}img_alerts`}>抢光了</div>)
          : (data.status === 11 && <div className={`${prefixCls}img_alerts`}>抢光了</div>)
        }

        {/* 加入购物车 */}
        {!data.virtual && (
          <div 
            className={`${prefixCls}add_car_icon${isSpecial ? '-s' : ''}`} 
            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
              e.stopPropagation();
              shopHomeJia(data);
            }}
          />
        )}

        {/* 专题按钮区域 */}
        {isSpecial && (
          <div className={`${prefixCls}-item-btn-box`}>
            {isApp ? (
              <div
                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                  e.stopPropagation();
                  if (shareProc) {
                    shareProc(data);
                  }
                }}
                className={`${prefixCls}-share-earn`}
              >
                分享赚￥{data.commission}
                <img src={require('../../images/share-white.png')} alt="" />
              </div>
            ) : (
              <span 
                onClick={(e: React.MouseEvent<HTMLSpanElement>) => this.toAppDetail(data, e)}
              >
                立即购买
              </span>
            )}
          </div>
        )}
      </div>
    );
  }

  static contextTypes = {
    router: PropTypes.object
  };
}

export default AppList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/AppList.tsx